export const SYNC = "SYNC";
export const SYNC_DURATION = "SYNC_DURATION";
export const STIPA_STOI = "STIPA_STOI";
export const AUDIODAW_EDITOR = "AUDIODAW_EDITOR";

export function setFeatures() {
  const featureFlags = {};
  featureFlags[SYNC] = process.env.REACT_APP_SYNC_ENABLED === "true";
  featureFlags[SYNC_DURATION] = process.env.REACT_APP_SYNC_DURATION === "false";
  featureFlags[STIPA_STOI] = process.env.REACT_APP_STIPA_STOI === "true";
  featureFlags[AUDIODAW_EDITOR] =
    process.env.REACT_APP_AUDIODAW_EDITOR === "true";
  return featureFlags;
}

export const NON_REACT_FEATURE_FLAGS = {
  allowPolyphonicWAV: process.env.REACT_APP_ALLOW_POLYPHONIC_WAV === "false",
};
